'use client';
import Carousel, { CarouselItem } from '@/components/@base/carousel';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';

import { DATA_CY_ABOUT_BENEFITS } from '@/constant/cypress';
import { pageLevelLocalization } from '@/constant/localization';

import BenefitCard from './benefitCard';
import benefitsData from './beneftisData';

export default function Benefits() {
  const {
    content: {
      aboutUs: { benefits: benfitsLocalization },
    },
  } = pageLevelLocalization;
  return (
    <>
      <Container className='my-10 flex flex-col items-center'>
        <Heading
          type={HEADING_TYPE.H2}
          className='text-[26px] font-medium leading-9 tracking-tight text-[#424244]'
        >
          {benfitsLocalization.benefits_and_services}
        </Heading>
        <Text className='font-light mt-2 text-base leading-5 tracking-tighter text-[#878F9B]'>
          {benfitsLocalization.why_we_are_the_best}
        </Text>
      </Container>

      <Container data-cy={DATA_CY_ABOUT_BENEFITS} className='w-full'>
        <Carousel
          spaceBetween={20}
          centeredSlides
          centeredSlidesBounds
          slidesPerView='auto'
          initialSlide={1}
        >
          {benefitsData.map((item, index) => (
            <CarouselItem key={index} className='w-72!'>
              <BenefitCard data={item} />
            </CarouselItem>
          ))}
        </Carousel>
      </Container>
    </>
  );
}
